import React from 'react';
import { useState } from 'react';
import StructureBanner from '../../Structure/Components/StructureBanner';
import { StructureInstallationProduct, StructureProduct } from '../../Structure/Components/StructureProduct';
import { FaLongArrowAltRight } from 'react-icons/fa';
import { FaLongArrowAltLeft } from "react-icons/fa";
import {structureItemData, structureInstallation}from '../../Structure/Components/structureItem';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { stepUp, stepBack } from '../../../Redux/Slice/stepSlice';



const StructureInstallation = () => {

  const dispatch = useDispatch()
  const steps = useSelector((state) => state.step.value)

  return (
    <div>
      <div>
      <StructureBanner />
      <div>
        <div>
          <div className="finalization container px-5">
            <div className="px-5">
              <div className="px-5">
                <section className="px-5">
                  <div className="container">
                    <div className="taille-de-terrace p-2">
                      <span className="text">TAILLE DE VOTRE TERRACE</span>
                    </div>
                  </div>
                  <div className="indiquez-surface container mt-5 d-flex align-items-center">
                    <label>Indiquez la surface de votre terrace</label>
                    <input
                      type="text"
                      className="border-end-0 ms-4"
                      style={{ width: "auto" }}
                    />
                    <div className="M2">
                      <span className="text-2">M2</span>
                    </div>
                  </div>
                  <div className="calcul container mt-5">
                    <p className="">Calcul : largeur * longueur</p>
                    <p className="" style={{ fontWeight: "bold" }}>
                      Anticipez les chutes en majorant votre surface de 5%
                    </p>
                  </div>
                  <div className="container mt-5">
                    <div className="votre-sol p-2">
                      <span className="text">VOTRE TYPE DE SOL</span>
                    </div>
                  </div>
                  <div className="container py-5">
                    <div className="row">
                      {structureItemData.map((product, index) => (
                        <div
                          key={index}
                          className="col-md-6 col-12 px-3 mb-3"
                        >
                          <StructureProduct
                            imageUrl={product.imageUrl}
                            label={product.label}
                            showCheckbox={product.showCheckbox}
                          />
                        </div>
                      ))}
                    </div>
                  </div> 
                  <div className="container">
                    <div className="pose p-2">
                      <span className="text">POSE SUR SOL MEUBLE</span>
                    </div>
                    <p className="mt-4">
                      Pour une pose sur terre meuble, nous vous conseillons d’enlever la
                      terre sur 20 à 25cm de profondeur et d’ajouter une membrane
                      géotextile puis de remplir d’un matériau concassable
                    </p>
                  </div>
                  <div className="container py-5">
                    <div className="row">
                      {structureInstallation.map((product, index) => (
                        <div key={index} className="col-md-4 col-12 px-3 mb-3">
                          <StructureInstallationProduct
                            image={product.image}
                            name={product.name}
                            checkbox={product.checkbox}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div className="d-flex">
            <div className="m-auto">
              {/* <span className="btn btn-secondary box-green mb-5 rounded-0 text-2" >
                  <Link to="/fixture" className='d-flex align-items-center ps-4' onClick={()=> dispatch(stepUp())}>
                    
                    SUIVANT <FaLongArrowAltRight className='ms-2'/>
                  </Link>  
              </span> */}
              <div className="d-flex justify-content-center mb-5">
                <div className="bois-de-pays me-2">
                  <span className="text-2 span">
                    <Link to="/structure" className='d-flex  align-items-center' onClick={ ()=> dispatch(stepBack()) }>
                      <FaLongArrowAltLeft className='me-3' />  MODIFIEZ
                    </Link>
                  </span>
                </div>
                <div className="btn btn-secondary box-green rounded-0" >
                  <span className="text-2 " >
                    <Link to="/fixture" className="d-flex align-items-center ps-4" onClick={ ()=> dispatch(stepUp()) }>
                      SUIVANT  <FaLongArrowAltRight  className='ms-2'/>
                    </Link>
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="m-auto">
                  <nav aria-label="...">
                    <ul className="pagination pagination-sm rounded-0">
                      <li className="page-item rounded-0" aria-current="page">
                        <Link className="page-link rounded-0 " to="#">
                          1
                        </Link>
                      </li>
                      <li className="page-item active">
                        <Link className="page-link rounded-0">2</Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link rounded-0" to="#">
                          3
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link " to="#">
                          4
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default StructureInstallation